/* eslint-disable no-param-reassign */

import type { SyntheticEvent } from "react";

export const imageFallback =
  "https://d31jk6ljx7wihh.cloudfront.net/images/thumb-default@2x.webp";

export function onImageError(event: SyntheticEvent<HTMLImageElement, Event>) {
  event.currentTarget.src = imageFallback;
  event.currentTarget.srcset = imageFallback;
}
